import {ReportingTrackersParams} from 'src/app/core/model/reporting';
import * as moment from 'moment-timezone';
import {Project} from 'src/app/core/model/project';

export function getInitialReportingTrackerParams(
  timezone: string,
  projectsMap: Record<string, Project>
): ReportingTrackersParams {
  const filteredMap = Object.fromEntries(Object.entries(projectsMap).filter(([, project]) => !project.isChallenge));
  const startDate = moment().tz(timezone).startOf('isoWeek').format();
  const endDate = moment().tz(timezone).endOf('isoWeek').format();
  let projectId: string;
  const storedProjectId = sessionStorage.getItem('ophStoredProjectId');

  if (storedProjectId && filteredMap[storedProjectId]) {
    projectId = storedProjectId;
  } else {
    projectId = Object.keys(filteredMap)[0];
  }

  return {
    page: 1,
    pageSize: 100,
    startDate,
    endDate,
    projectId,
  };
}
